<template>
  <div id="app">
    <div class="preloader" v-if="preloader">
      <h4>Идет загрузка сайта..</h4>
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div>
    <header12 v-if="!preloader"></header12>
    <router-view v-if="!preloader" />
    <footer12 v-if="!preloader"></footer12>
  </div>
</template>

<script>
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  import '@fortawesome/webfonts/css/fontawesome-all.min.css'
  import './assets/css/fonts.css'
  import './assets/css/style.css'
  import './assets/css/preloader.css'
  import footer from './components/footer'
  import header from './components/header'
  import axios from 'axios'

  export default {
    data() {
      return {
        preloader: true,
      }
    },
    components: {
      'footer12': footer,
      'header12': header,
    },
    name: 'App',
    computed: {
      config() {
        return this.$store.state.config
      },
    },
    mounted() {
      var vm = this
      axios.get(vm.config.url + vm.config.get_api + vm.config.id).then(
        res => {
          var tokens = {
            'headers': {
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + res.data
            }
          }
          axios.get(vm.config.url + vm.config.api_url + vm.config.id + vm.config.products, tokens)
            .then(
              res => {
                vm.$store.commit('api', res.data)
                setTimeout(function () {
                  vm.preloader = false;
                }, 1000);
              })
        })
    }
  }

</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue